import { render, staticRenderFns } from "./ManualRulesGridAssign.vue?vue&type=template&id=346dc43b&scoped=true&"
import script from "./ManualRulesGridAssign.vue?vue&type=script&lang=ts&"
export * from "./ManualRulesGridAssign.vue?vue&type=script&lang=ts&"
import style0 from "./ManualRulesGridAssign.vue?vue&type=style&index=0&id=346dc43b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346dc43b",
  null
  
)

export default component.exports